import { BaseModel } from './base.model';
import { JsonObject } from '../helpers';
import { PropModel } from './prop.model';
import { has } from 'lodash';

export class PortalConfig extends PropModel {
  enabled: boolean;
  historyEnabled: boolean;
  availablePrivateModelIds: string[];

  constructor(props: JsonObject = {}) {
    super();
    const data = props as Record<keyof PortalConfig, unknown>;
    this.enabled = has(data, 'enabled') ? !!data.enabled : false;
    this.historyEnabled = has(data, 'historyEnabled') ? !!data.historyEnabled : false;
    this.availablePrivateModelIds = (data.availablePrivateModelIds as string[]) || [];
  }
}

type PublicServiceBlockAction = 'redirect-portal' | 'block' | 'redirect-url';

class PolicyAclList extends PropModel {
  enabled: string[];
  disabled: string[];

  constructor(props: JsonObject = {}) {
    super();

    const data = props as Record<keyof PolicyAclList, unknown>;
    this.enabled = (data.enabled as string[]) || [];
    this.disabled = data.disabled as string[] | [];
  }
}

class PublicServiceConfig extends PolicyAclList {
  blockAction: 'redirect-portal' | 'block' | 'redirect-url';
  redirectUrl: string;
  monitored: string[];

  constructor(props: JsonObject = {}) {
    super(props);
    const data = props as Record<keyof PublicServiceConfig, unknown>;
    this.blockAction = (data.blockAction as PublicServiceBlockAction) || 'block';
    this.redirectUrl = (data.redirectUrl as string) || '';
    this.monitored = (data.monitored as string[]) || [];
  }
}

export class PolicyModel extends BaseModel {
  portal: PortalConfig;
  publicServices: PublicServiceConfig;
  contextDataSources: PolicyAclList;
  assistants: PolicyAclList;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof PolicyModel, unknown>;
    this.portal = new PortalConfig((data.portal as JsonObject) || {});
    this.publicServices = new PublicServiceConfig((data.publicServices as JsonObject) || {});
    this.contextDataSources = new PolicyAclList((data.contextDataSources as JsonObject) || {});
    this.assistants = new PolicyAclList((data.assistants as JsonObject) || {});
  }

  get allAvailablePublicServices(): string[] {
    return [...this.publicServices.monitored, ...this.publicServices.enabled];
  }

  get agents(): string[] {
    return this.assistants.enabled;
  }

  get datasources(): string[] {
    return this.contextDataSources.enabled;
  }

  get privateModels(): string[] {
    return this.portal.availablePrivateModelIds;
  }
}
